export default {
  computed: {
    allMembersRevenue: function () {
      return this.$store.state.ChartStore.member_revenue_data
    }
  }
}
